import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import classNames from 'classnames';
import s from './ExpertData.scss';
import ExpertDataProjects from './ExpertDataProjects';
import ExpertDataAbout from './ExpertDataAbout';
import ExpertDataReviews from './ExpertDataReviews';
import ExpertDataServices from './ExpertDataServices';
import { Text } from 'wix-style-react';
import { Link, Element } from 'react-scroll';
import { ExpertAvailablityStatus, KeyCode } from '../../../utils/constants';
import { ServicesProvider } from '@wix/experts-common';

class ExpertData extends React.Component {
  static propTypes = {
    t: PropTypes.func,
    onGetQuoteClick: PropTypes.func,
    expert: PropTypes.object,
    isMyProfile: PropTypes.bool,
    staticsBaseUrl: PropTypes.string,
  };

  static defaultProps = {
    isMyProfile: false,
  };

  render() {
    const {
      t,
      expert,
      onGetQuoteClick,
      isMyProfile,
      staticsBaseUrl,
    } = this.props;
    const { withBI, isInModal } = this.context.services;
    const isExpertUnAvailable =
      expert.status === ExpertAvailablityStatus.UnAvailable;
    const reviews = expert.reviews;
    const reviewScores = expert.reviewScores;
    const hasReviews = expert.reviews && expert.reviews.length > 0;
    const navLinksArray = [
      {
        name: 'projects',
        title: 'client-expertview-subnav-projects',
        offset: isInModal ? -120 : -200,
      },
      {
        name: 'about',
        title: 'client-expertview-subnav-aboutme',
        offset: isInModal ? -100 : -180,
      },
      {
        name: 'services',
        title: 'client-expertview-subnav-servicerates',
        offset: isInModal ? -50 : -130,
      },
    ];
    if (hasReviews) {
      navLinksArray.push({
        name: 'reviews',
        title: 'client-expertview-subnav-reviews',
        offset: isInModal ? -50 : -130,
      });
    }

    const navLinks = navLinksArray.map((navLink, index) => {
      return (
        <li key={index}>
          <Link
            data-link-name={navLink.name}
            data-hook="expert-data-nav-link"
            className={s.navLink}
            activeClass={s.active}
            to={navLink.name}
            spy={true}
            hashSpy={true}
            smooth={true}
            isDynamic={true}
            offset={navLink.offset}
            duration={500}
            onClick={() => {
              withBI({
                evid: 28,
                typeid: 1,
                proGuid: expert.id,
                newTabName: navLink.name,
                origTabName: '',
              });
              document.querySelector(`[name='${navLink.name}']`).focus();
            }}
          >
            <Text
              tabIndex={0}
              role="button"
              className={s.navLinkText}
              size="medium"
              skin="standard"
              tagName="span"
              weight="normal"
              onKeyUp={e => {
                e.keyCode === KeyCode.Enter && e.target.parentElement.click();
              }}
            >
              {t(navLink.title)}
            </Text>
          </Link>
        </li>
      );
    });

    return (
      <div className={s.expertDataContainer}>
        <nav className={s.navLinksContainer}>
          <ul>{navLinks}</ul>
        </nav>
        <div className={classNames(s.dataWrapper)}>
          <div
            className={classNames(
              s.whiteContainer,
              s.expertDataProjectsContainer,
            )}
            data-hook="expert-data-projects-and-about"
          >
            <Element
              name={navLinksArray[0].name}
              className={s.elementContainer}
              tabIndex={-1}
            >
              <ExpertDataProjects
                projects={expert.personalDetails.portfolio.values}
                expertGuid={expert.id}
                isMyProfile={isMyProfile}
                staticsBaseUrl={staticsBaseUrl}
              />
            </Element>
            <div className={s.lineSeparator} />
            <Element
              name={navLinksArray[1].name}
              className={s.elementContainer}
              tabIndex={-1}
            >
              <ExpertDataAbout
                expertName={expert.personalDetails.name}
                about={expert.personalDetails.about}
                additionalInfo={expert.personalDetails.additionalInfo}
                expertGuid={expert.id}
                isMyProfile={isMyProfile}
              />
            </Element>
          </div>
          <Element
            name={navLinksArray[2].name}
            className={s.elementContainer}
            tabIndex={-1}
          >
            <div className={s.whiteContainer} data-hook="expert-data-services">
              <ExpertDataServices
                supportedServices={expert.supportedServices}
                onGetQuoteClick={onGetQuoteClick}
                showButton={!isExpertUnAvailable && !isMyProfile && !isInModal}
                isMyProfile={isMyProfile}
                expertGuid={expert.id}
              />
            </div>
          </Element>
          {hasReviews && navLinksArray[3] && (
            <Element
              name={navLinksArray[3].name}
              className={s.elementContainer}
              tabIndex={-1}
            >
              <div className={s.whiteContainer} data-hook="expert-data-reviews">
                <ExpertDataReviews
                  reviews={reviews}
                  reviewScores={reviewScores}
                  expertGuid={expert.id}
                  expertDetails={expert.personalDetails}
                  isMyProfile={isMyProfile}
                />
              </div>
            </Element>
          )}
        </div>
      </div>
    );
  }
}

ExpertData.contextTypes = ServicesProvider.childContextTypes;
export default translate()(ExpertData);
